"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = ErrorList;

var _react = _interopRequireDefault(require("react"));

function ErrorList(props) {
  var errors = props.errors;
  return _react["default"].createElement("div", {
    "data-notification": true,
    className: "bx--toast-notification bx--toast-notification--error",
    role: "alert",
    style: {
      width: '100%'
    }
  }, _react["default"].createElement("div", {
    className: "bx--toast-notification__details"
  }, _react["default"].createElement("h3", {
    className: "bx--toast-notification__title"
  }, "Erros"), _react["default"].createElement("p", {
    className: "bx--toast-notification__subtitle"
  }, errors.map(function (error, i) {
    return error.stack;
  }))));
}